import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { IsoDate } from '../definitions/Common';
import Applicant from './Applicant';
import Motorcycle from './Motorcycle';


const Application = types
    .model('Application', {
        id: types.optional(types.identifier, () => uuid()),
        applicant: types.maybe(Applicant),
        motorcycle: types.maybe(Motorcycle),

        policyStart: types.maybe(IsoDate),
    });

export default Application;
